<template>
  <div id="page-product-documents-ipr-wording-form">
    <vs-row >
      <vs-col>
        <vs-row>
          <vs-col>
            <h2 class="mb-1">{{ pageTitle }}</h2>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col>
            <card-page>
              <vue-element-loading :active="busy"></vue-element-loading>
              <div class="flex justify-between">
                <div class="w-1/2">
                  <h3 v-if="isEdit" class="m-4">Edit document</h3>
                  <vue-form-generator
                      :schema="schema"
                      :model="model"
                      :options="formOptions"
                      ref="form"
                  />
                </div>
                <div v-if="isEdit" class="w-1/2">
                  <h3 class="m-4">Upload New File</h3>
                  <document-upload-form
                      :model="model"
                      ref="additional"
                  />
                </div>
              </div>
              <div class="w-full" v-if="isEdit">
                <document-grid
                    :apiModel="apiModel"
                    :model="model"
                    :ProductCompanyType="ProductCompanyType"
                    :ProductCompanyType_FK="ProductCompanyType_FK"
                />
              </div>
            </card-page>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import DocumentGrid from "@/views/pages/product-documents-ipr/DocumentGrid";
import DocumentUploadForm from "@/views/pages/product-documents-ipr/DocumentUploadForm";
import ProductDocumentUploadFormMixin from "@/components/mixins/ProductDocumentUploadFormMixin";
import FormModelMixin from "@/components/mixins/FormModelMixin";
import FormFieldValidationMixin from "@/components/mixins/FormFieldValidationMixin";
import {selectOptions} from '@/components/form/FormElementOption';
import {validateFileType} from "../../../../validation/Vfg/resources";
import CardPage from '../../../components/Views/CardPage';

export default {
  name: "WordingIprForm",
  components: {
    DocumentGrid,
    DocumentUploadForm,
    CardPage
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    forms: {
      type: Array,
      default: () => [
        'form',
      ]
    },
    ProductCompanyType: {
      type: String,
      required: true,
    },
    ProductCompanyType_FK: {
      type: Number,
      required: true,
    },
  },
  mixins: [FormModelMixin, ProductDocumentUploadFormMixin, FormFieldValidationMixin],
  data() {
    return {
      selectedReferences: [],
      options: [
        {
          endpoint: () => this.$api.riskCode.list(),
          optionsFieldName: 'riskCodeReferences',
          nameFieldName: 'RiskCodeText',
          idFieldName: 'RiskCode_FK',
        },
      ],
      model: {
        WordingCode: '',
        IsSignatureSkip: 0,
        IsEnabled: 0,
        IsActiveDocument: 0,
        InsuringClause: null,
        RiskCode_FK: null,
        File: null,
        FriendlyName: null,
      },
      schema: {
        groups: [
          {
            styleClasses: "w-full",
            fields: [
              {
                type: "input",
                inputType: "text",
                styleClasses: "md:w-1/2 w-full",
                label: "Friendly Name",
                model: "FriendlyName",

                required: true,

                validator: () => {
                  if (this.model.FriendlyName && this.model.FriendlyName.length > 0) {
                    return true;
                  }

                  return 'This field is required';
                },
                visible: () => !this.model.id,
              },
            ],
          },
          {
            styleClasses: "w-full",
            fields: [
              {
                type: "upload",
                inputType: "file",
                styleClasses: "w-full",
                label: "File",
                model: "File",
                placeholder: "",
                required: true,
                validator: [() => {
                  if (this.model.hasOwnProperty("File") && this.model.File) {
                    return true;
                  }

                  return 'This field is required';
                }, validateFileType(['pdf', 'jpg', 'jpeg', 'png', 'doc', 'docx', 'xls', 'xlsm'])],
                files: true,
                onChanged: (model, schema, event, instance) => {
                  this.model.File = instance.$el.children[0].files[0];

                  instance.validate();
                },
                visible: () => !this.model.id,
              },

            ],
          },
          {
            styleClasses: "w-full",
            fields: [
              {
                type: "vueMultiSelect",
                inputType: "text",
                styleClasses: "md:w-4/5 w-full",
                label: "Risk Code",
                model: "RiskCode_FK",
                values: () => this.riskCodeReferences,
                selectOptions,
              },
            ],
          },
          {
            styleClasses: "w-full",
            fields: [
              {
                type: "input",
                inputType: "text",
                styleClasses: "md:w-4/5 w-full",
                label: "Wording Code",
                model: "WordingCode",

                validator: 'string',
                required: true,
              },
            ],
          },
          {
            styleClasses: "w-full",
            fields: [
              {
                type: "textArea",
                label: "Insuring Clause",
                model: "InsuringClause",
                styleClasses: "md:w-4/5 w-full",
                //max: 500,
                placeholder: "",
                rows: 4,
                validator: 'string',
              },
            ],
          },
          {
            styleClasses: "w-full",
            fields: [
              {
                type: "vsCheckbox",
                styleClasses: "md:w-1/2 w-full",
                label: "Is Signature Skip",
                model: "IsSignatureSkip",
              },
            ],
          },
        ],
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
      },
      riskCodeReferences: [],
      formReferences: this.forms,
    };
  },
  computed: {
    pageTitle() {
      if (!this.model) {
        return '';
      }

      let mode = `Create a Wording`;

      if (this.model.hasOwnProperty("id") && this.model.id > 0) {
        mode = `Wording #${this.model.id}`
      }

      return mode;
    },
    isEdit() {
      return (this.model.hasOwnProperty("id") && this.model.id > 0);
    },
  },
};
</script>

<style scoped>

</style>
